import jsPDF from "jspdf";
import {ToBritishDate} from "../utilities/ToMySqlDate";
import {autoTable} from 'jspdf-autotable'
import {printFormatNumber, sF} from "../utilities/NumberFormatter";

export function CommissionPrint(body, name,month,group) {
    let bList = []
    let commissionTotal = ['Summery', 0, 0, 0,0,0];
    let i = 0
    body.forEach(element => {
        const b = [
            `${element.name.trim()}`,
            printFormatNumber(element.sale.toLocaleString()),
            printFormatNumber(element.purchase.toLocaleString()),
            printFormatNumber(element.receipt.toLocaleString()),
            printFormatNumber(element.bounced.toLocaleString()),
            printFormatNumber(element.total.toLocaleString()), ]
        commissionTotal[1] += sF(element.sale);
        commissionTotal[2] += sF(element.purchase);
        commissionTotal[3] += sF(element.receipt);
        commissionTotal[4] += sF(element.bounced);
        commissionTotal[5] += sF(element.total);
        bList = [...bList, b]

    })
    const doc = new jsPDF({
        orientation: "portrait",
        unit: "px",
        format: "a4",
    });
    const heading = ['Name', 'Sales', 'Purchase', 'Receipt', 'Bounced', 'Total'];
    let y = 10
    doc.text(name, 20, y = y + 30,);
    doc.text("Commission Report", 270, 40)
    doc.text(`Month:${month}`, 20, 55)
    doc.text(`Group:${group}`, 150, 55)
    doc.text(`Date:${ToBritishDate(new Date())}`, 270, 55)
    autoTable(doc, {
            headStyles: {fontSize: 8, halign: 'right'},
            footStyles: {fontSize: 8, halign: 'center'},
            bodyStyles: {fontSize: 8, cellWidth: "auto"},
            showFoot: "lastPage",
            head: [heading],
            startY: 70,
            theme: 'grid',
            body: bList.map(item => {
                return item
            }),
            foot: [commissionTotal.map((item,index) => {
                if(index === 0){
                    return item
                } else {
                   return  printFormatNumber(item.toLocaleString())
                }

            })],

            columnStyles: {
                0: {halign: "Left",cellWidth:100},
                1: {halign: "right", cellWidth:50},
                2: {halign: "right", cellWidth:50},
                3: {halign: "right", cellWidth:50},
                4: {halign: "right", cellWidth:50},
                5: {halign: "right", cellWidth:50},
            },
        }
    )
    doc.save(`CommissionAt-${group}-${month}.pdf`);
}



